module.exports = __webpack_public_path__ + "assets/img/btn-view-13281733.png";